module.exports = __webpack_public_path__ + "img/no-movie.19986b5f.png";